module.exports = __webpack_public_path__ + "static/media/18-11.136af402.mp3";